import React, { FC } from 'react';
import Schema from '../../../../../../lib/paths/zwischenbericht_FULL_Paths.json';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../context/ApplicationContext';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
import { PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
const P = Schema.attributes;

const Abweichung: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title="Abweichung in Projektfortschritt und Mittelkalkulation" description={PLATZHALTER_TEXT} />
			<CreateForm
				formStruc={formStrucAbweichung}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={readOnly}
			/>
		</>
	);
};
export default Abweichung;

export const formStrucAbweichung = [
	{
		fields: [P.Abweichungen_In_Projektf_0097334775_ttelkalkulation_Beschreibung],
		userProps: { columnToDivide: 1 },
	},
];
